<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- FORMULÁRIO -->
<div *ngIf="!loading" class="h-[calc(100dvh-10rem)] max-w-[624px] mx-auto mt-4">
  <form [formGroup]="providerForm" (ngSubmit)="submit()">
    
    <!-- HEADER -->
    <div class="border-b pb-4">
      <p class="font-medium text-base text-westetics-neutral-950">
        {{ isRoot ? 'Editar Prestador' : 'Visualizar Prestador' }}
      </p>
      <p class="text-sm text-westetics-neutral-800 mt-2">
        {{ isRoot ? 'Atualize os dados do prestador' : 'Dados do prestador (somente leitura)' }}
      </p>
    </div>

    <!-- NOME DO PRESTADOR -->
    <div class="border-b pb-4 mt-4">
      <div class="w-full">
        <label for="name" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
          Nome do Prestador*
        </label>
        <input 
          type="text" 
          id="name" 
          formControlName="name"
          class="bg-gray-50 border border-gray-300 text-westetics-neutral-800 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
          placeholder="Insira o nome do prestador" 
        />
        <span 
          class="text-red-600 text-sm mt-1" 
          *ngIf="providerForm.controls['name']?.invalid && providerForm.controls['name']?.touched">
          Insira um nome válido.
        </span>
      </div>
    </div>

    <!-- CONSELHO PROFISSIONAL + PROFISSÃO -->
    <div class="border-b pb-4 mt-4 grid grid-cols-2 gap-4">
      <div>
        <app-custom-dropdown
          [options]="professionalCouncils"
          [label]="'Conselho Profissional*'"
          [placeholder]="'Selecione o Conselho Profissional'"
          formControlName="professionalCouncil">
        </app-custom-dropdown>
        <span 
          class="text-red-600 text-sm mt-1" 
          *ngIf="providerForm.controls['professionalCouncil']?.invalid && providerForm.controls['professionalCouncil']?.touched">
          Selecione um conselho profissional.
        </span>
      </div>

      <div>
        <app-custom-dropdown
          [options]="professions"
          [label]="'Profissão*'"
          [placeholder]="'Selecione a Profissão'"
          formControlName="profession">
        </app-custom-dropdown>
        <span 
          class="text-red-600 text-sm mt-1" 
          *ngIf="providerForm.controls['profession']?.invalid && providerForm.controls['profession']?.touched">
          Selecione uma profissão.
        </span>
      </div>
    </div>

    <!-- REGISTRO PROFISSIONAL -->
    <div class="border-b pb-4 mt-4">
      <div class="w-full">
        <label for="professionalRegistration" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
          Registro Profissional*
        </label>
        <input 
          type="text" 
          id="professionalRegistration" 
          formControlName="professionalRegistration"
          class="bg-gray-50 border border-gray-300 text-westetics-neutral-800 text-sm rounded-lg outline-none focus:ring-westetics-blue focus:border-westetics-blue block w-full p-2.5"
          placeholder="Insira o registro profissional" 
        />
        <span 
          class="text-red-600 text-sm mt-1" 
          *ngIf="providerForm.controls['professionalRegistration']?.invalid && providerForm.controls['professionalRegistration']?.touched">
          Insira um registro profissional válido.
        </span>
      </div>
    </div>

    <!-- BOTÕES (responsivo: empilha em mobile/tablet, centralizados em desktop) -->
    <div class="flex flex-col md:flex-row md:justify-center items-center gap-3 my-6">
      <button 
        type="button" 
        (click)="cancel()"
        class="w-full md:w-44 px-4 py-2 md:py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border text-sm md:text-base"
    >
        {{ isRoot ? 'Cancelar' : 'Voltar' }}
      </button>
      <button 
        *ngIf="isRoot"
        type="submit"
        class="w-full md:w-44 px-4 py-2 md:py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg text-sm md:text-base"
        [disabled]="providerForm.invalid">
        Salvar
      </button>
    </div>

  </form>
</div>
